import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { actions } from "redux-store";
import { EventTypes } from "redux-store/slices/events/events.interfaces";
import { useMediaQuery, useTheme } from "@mui/material";

export const useHomePage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTooNarrow = useMediaQuery("(max-width:380px)");

  const onButtonPressed = useCallback(() => {
    window.location.href = "#/choose-level";
  }, []);

  dispatch(
    actions.dispatchEvent({
      eventType: EventTypes.QUIZ_VIEW,
      extraData: { quizStepName: "Home page" },
    }),
  );

  return { isMobile, onButtonPressed, isTooNarrow };
};
